import type { AcfObjectType } from "../../types";

export const ACF_TYPE_LABEL: Record<AcfObjectType, string> = {
  "field-groups": "Field group",
  "post-types": "Post type",
  "taxonomies": "Taxonomy",
  "options-pages": "Options page",
};

export const ACF_TYPE_COLOR: Record<AcfObjectType, string> = {
  "field-groups": "blue",
  "post-types": "volcano",
  "taxonomies": "gold",
  "options-pages": "purple",
};
